var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIdCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 3.5H6.99935C5.71068 3.5 4.66602 4.54467 4.66602 5.83333V24.5C4.66602 25.7887 5.71068 26.8333 6.99935 26.8333H20.9993C22.288 26.8333 23.3327 25.7887 23.3327 24.5V5.83333C23.3327 4.54467 22.288 3.5 20.9993 3.5Z",
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 9.3335C13.5379 9.3335 13.0867 9.47034 12.703 9.72673C12.3193 9.98312 12.0202 10.3475 11.8436 10.7739C11.667 11.2003 11.6208 11.6694 11.7109 12.122C11.8009 12.5747 12.0231 12.9904 12.3494 13.3167C12.6758 13.6431 13.0915 13.8653 13.5441 13.9553C13.9968 14.0454 14.4659 13.9992 14.8923 13.8225C15.3186 13.6459 15.6831 13.3469 15.9394 12.9632C16.1958 12.5794 16.3327 12.1283 16.3327 11.6668C16.3327 11.048 16.0869 10.4545 15.6493 10.0169C15.2117 9.57933 14.6182 9.3335 13.9994 9.3335Z",
    fill: "#6B758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 18.6665C18.6673 17.7382 18.2986 16.848 17.6422 16.1916C16.9858 15.5353 16.0956 15.1665 15.1673 15.1665H12.834C11.9057 15.1665 11.0155 15.5353 10.3591 16.1916C9.70273 16.848 9.33398 17.7382 9.33398 18.6665C9.33398 18.9759 9.4569 19.2727 9.67569 19.4915C9.89449 19.7103 10.1912 19.8332 10.5007 19.8332H17.5007C17.8101 19.8332 18.1068 19.7103 18.3256 19.4915C18.5444 19.2727 18.6673 18.9759 18.6673 18.6665Z",
    fill: "#6B758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.1665H16.3333C16.6428 1.1665 16.9395 1.28942 17.1583 1.50821C17.3771 1.72701 17.5 2.02375 17.5 2.33317V3.49984H10.5V2.33317C10.5 2.02375 10.6229 1.72701 10.8417 1.50821C11.0605 1.28942 11.3572 1.1665 11.6667 1.1665Z",
    fill: "#A0A6AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCard);
export default __webpack_public_path__ + "static/media/icon_id-card.863079f419b71a0f8fceb37c8dbc0b77.svg";
export { ForwardRef as ReactComponent };